export default function Dialog() {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '2rem 2rem 1rem 2rem',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '0.5rem 2rem 2rem 2rem',
        },
      },
    },
  };
}
